// extracted by mini-css-extract-plugin
module.exports = {"moreAccomodationsBase":"styles_moreAccomodationsBase__Lu_Jz","link":"styles_link__cLpfh"};